import React from 'react';
import PropTypes from 'prop-types';

import { OSLO_GRAY } from '@constant/colors';

const Instagram = ({ width }) => (
  <svg width={width} height={width} viewBox="0 0 17 18">
    <path
      d="M8.497.005c-2.307 0-2.597.01-3.503.05C4.09.1 3.472.242 2.93.452c-.558.22-1.03.51-1.504.982-.472.472-.763.946-.98 1.505C.236 3.47.092 4.09.05 5 .01 5.905 0 6.194 0 8.502c0 2.307.01 2.597.05 3.503.042.905.186 1.522.396 2.063.217.558.508 1.03.98 1.504.473.472.946.763 1.505.98.55.21 1.16.354 2.07.395.91.04 1.2.05 3.51.05s2.6-.01 3.507-.05c.905-.042 1.523-.186 2.063-.396.56-.21 1.032-.5 1.504-.98.476-.47.766-.94.98-1.5.21-.54.357-1.16.4-2.06.04-.9.05-1.19.05-3.5s-.01-2.593-.05-3.5c-.043-.905-.186-1.523-.396-2.063-.22-.56-.51-1.033-.98-1.505-.472-.47-.946-.76-1.506-.98-.54-.205-1.16-.35-2.06-.39C11.1.02 10.81.01 8.505.01zm0 1.53c2.27 0 2.538.01 3.434.05.83.04 1.28.177 1.58.294.4.15.68.33.98.63.3.3.48.58.64.97.12.3.26.75.3 1.58.04.89.05 1.16.05 3.43 0 2.27-.01 2.533-.05 3.43-.04.83-.175 1.28-.292 1.576-.153.4-.337.68-.634.98-.3.3-.58.483-.977.64-.3.114-.75.253-1.58.29-.895.04-1.164.05-3.433.05-2.27 0-2.54-.01-3.437-.05-.83-.038-1.28-.177-1.577-.293-.4-.156-.68-.34-.98-.638-.3-.297-.48-.58-.636-.977-.114-.3-.253-.75-.29-1.578-.04-.895-.05-1.163-.05-3.43 0-2.27.01-2.54.05-3.436.038-.83.177-1.28.293-1.58.154-.393.338-.676.636-.974.3-.3.58-.48.98-.637.3-.12.75-.26 1.575-.297.896-.04 1.164-.05 3.43-.05z"
      fill={OSLO_GRAY}
      fillRule="evenodd"
    />
    <path
      d="M8.497 11.335c-1.564 0-2.832-1.268-2.832-2.832 0-1.565 1.268-2.833 2.832-2.833 1.565 0 2.833 1.268 2.833 2.833 0 1.564-1.268 2.832-2.833 2.832zm0-7.196c-2.41 0-4.363 1.95-4.363 4.36s1.953 4.36 4.363 4.36 4.363-1.95 4.363-4.36-1.95-4.36-4.36-4.36zm5.556-.18c0 .56-.457 1.02-1.02 1.02s-1.02-.46-1.02-1.02.457-1.02 1.02-1.02 1.02.45 1.02 1.02z"
      fill={OSLO_GRAY}
      fillRule="evenodd"
    />
  </svg>
);

Instagram.propTypes = {
  width: PropTypes.number,
};

Instagram.defaultProps = {
  width: 20,
};

export default Instagram;
